import React, { useState, useEffect, useRef } from 'react';
import './ProgramDetails.css';
import { useNavigate } from 'react-router-dom';
import { initFacebookPixel } from '../facebookPixel';
const ProgramDetails = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoSlidePaused, setIsAutoSlidePaused] = useState(false);
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const sliderData = [
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S4.png',
      title: 'Expertly Designed Curriculum',
      description: 'Our program, designed by Olympic Swimmer Nisha Millet, provides a structured and world-class learning experience.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S2.png',
      title: 'Trained & Certified Coaches',
      description: 'All coaches are trained by Nisha Millet and certified by the Sports Authority of India & ASCA for excellence.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S8.png',
      title: 'Unmatched Safety Standards',
      description: 'Certified lifeguards are always on duty, ensuring a safe and secure swimming environment for every participant.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S6.png',
      title: 'Personalized Learning',
      description: 'We maintain a low 1:10 coach-to-student ratio, allowing focused training and personalized skill development.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S5.png',
      title: 'Flexible Learning',
      description: 'Students can avail up to 3 compensation classes, ensuring they stay on track without missing progress.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S1.png',
      title: 'Achievement & Recognition',
      description: 'Every child receives a certificate upon camp completion, celebrating their learning and newly gained skills.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S7.png',
      title: 'Summer Camp Carnival',
      description: 'A special event where kids showcase their swimming skills and celebrate their achievements with excitement.',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/S3.png',
      title: 'Comprehensive Skill Development',
      description: 'Our structured curriculum covers safety, confidence, survival skills, freestyle, backstroke, and more.',
    },
  ];
  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + sliderData.length) % sliderData.length);
  };

  const pauseAutoSlide = () => {
    setIsAutoSlidePaused(true);
    setTimeout(() => setIsAutoSlidePaused(false), 3000); // Resume after 3 seconds
  };


  const getVisibleItems = () => {
    const visibleItems = [];
    for (let i = 0; i < 3; i++) {
      visibleItems.push(sliderData[(currentIndex + i) % sliderData.length]);
    }
    return visibleItems;
  };


  useEffect(() => {
    if (isAutoSlidePaused) return;
    const interval = setInterval(goToNext, 3000);
    return () => clearInterval(interval);
  }, [isAutoSlidePaused, currentIndex]); // Added currentIndex to prevent sync issues
  
  

  useEffect(() => {
    if (isMobile && sliderRef.current) {
      const slider = sliderRef.current;
      const cardWidth = slider.children[0].offsetWidth;
      slider.scrollTo({
        left: currentIndex * cardWidth,
        behavior: 'smooth',
      });
    }
  }, [currentIndex, isMobile]);
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
  
    let isScrolling;
  
    const handleScroll = () => {
      setIsAutoSlidePaused(true); // Pause auto-slide when user scrolls manually
      clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        setIsAutoSlidePaused(false); // Resume auto-slide after user stops scrolling
      }, 3000);
    };
  
    slider.addEventListener('scroll', handleScroll);
    return () => slider.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Touch event handlers for manual scrolling
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      goToNext(); // Swipe left
      pauseAutoSlide();
    } else if (touchEndX.current - touchStartX.current > 50) {
      goToPrev(); // Swipe right
      pauseAutoSlide();
    }
  };
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="program-details-container">
      <div className="floating-button"></div>
      <h2 className="program-title">PROGRAM BENEFITS</h2>
      {isMobile ? (
        <div
          className="mobile-slider-container"
          ref={sliderRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {sliderData.map((card, index) => (
            <div key={index} className="slider-card">
              <div className="card-image-container">
                <img src={card.imgSrc} alt={card.title} className="slider-image" />
              </div>
              <div className="slider-text">
                <h3 className="slider-title">{card.title}</h3>
                <p className="description">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        // Desktop view: Carousel
        <div
          className="slider-container"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <button className="nav-button prev" onClick={() => { goToPrev(); pauseAutoSlide(); }}>
            <span className="arrow">&larr;</span>
          </button>

          <div className="cards-container">
            {getVisibleItems().map((card, index) => (
              <div key={index} className="slider-card">
                <div className="card-image-container">
                  <img
                    src={card.imgSrc}
                    alt={card.title}
                    className="slider-image"
                  />
                </div>
                <div className="slider-text">
                  <h3 className="slider-title">{card.title}</h3>
                  <p className="description">{card.description}</p>
                </div>
              </div>
            ))}
          </div>

          <button className="nav-button next" onClick={() => { goToNext(); pauseAutoSlide(); }}>
            <span className="arrow">&rarr;</span>
          </button>
        </div>
      )}

      {/* Indicators for desktop view */}
      {!isMobile && (
        <div className="indicator-container">
          {sliderData.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => { setCurrentIndex(index); pauseAutoSlide(); }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProgramDetails;